import { ref, onMounted, getCurrentInstance } from "vue";
import { LD_FLAG_IDEA_MDP_614 } from "@components/constants/launchDarklyFlagKeys";

/** Resolves idea-MDP-614 (effective-dated Status + State display). Off until the flag resolves true. */
export function useEffectiveDatedFlag() {
  const { proxy } = getCurrentInstance() || {};
  const enabled = ref(false);

  onMounted(async () => {
    try {
      enabled.value = (await proxy?.$getFlag?.(LD_FLAG_IDEA_MDP_614, false)) === true;
    } catch {
      enabled.value = false;
    }
  });

  return enabled;
}
